import React from "react";
import Header5 from "../PageLayout/header5";
import Footer from "../PageLayout/Footer";
import LandingPage from "./LandingPage";

const MaintenanceBanner = () => (
  <div className="maintenance-banner">
    <span className="maintenance-title">Scheduled Maintenance</span>
    <span>
      Some functionality may be unavailable while we refresh the experience. Thank you for your patience while our
      team completes the upgrade.
    </span>
  </div>
);

export default function LandingHome(){
    return <>
        <Header5 />
        <MaintenanceBanner />
         <LandingPage />
        <Footer />
    </>
}
